// extracted by mini-css-extract-plugin
module.exports = {"mathgpt-logo":"mathgpt-logo___3K9ph","mathgpt-logo-left":"mathgpt-logo-left___1YFGL","mathgpt-logo-right":"mathgpt-logo-right___vduXJ"};